import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import {
  Modal,
  MoneyInput,
  TextAreaWithReadOnly,
  TextInputWithReadOnly,
  pencilIcon,
  trashGalleryIcon,
  GalleryVideo,
  plusIcon,
} from "../../Components";
import GalleryAdd from "../Gallery/GalleryAdd";
import { briefService, uploadService } from "../../Services";
import GalleryGridItem from "../MyProfile/GalleryGridItem";
export default function AddBrief({
  generatedBriefResponse,
  setTab,
  setToastList,
  toastList,
}) {
  const createList = useRef(null);
  const [showActionIcon, setShowActionIcon] = useState(false);
  const [form, setForm] = useState({
    user_id: generatedBriefResponse.user_id ?? "",
    input: generatedBriefResponse.description ?? "",
    title: generatedBriefResponse.title ?? "",
    goal: generatedBriefResponse.goal,
    scope_of_work: generatedBriefResponse.scope_of_work,
    timeline: generatedBriefResponse.timeline,
    budget: generatedBriefResponse.budget,
    additional_info: generatedBriefResponse.additional_info,
    source: generatedBriefResponse.source,
    files: [],
  });

  console.log(form);

  const [isLoadedImg, setIsLoadedImg] = useState(false);
  const [preview, setPreview] = useState([]);
  const [error, setError] = useState(true);
  const [errorText, setErrorText] = useState("");
  const [isError, setIsError] = useState(false);
  const [readOnlyTitle, setReadOnlyTitle] = useState(true);
  const [readOnlyGoal, setReadOnlyGoal] = useState(true);
  const [readOnlyScopeOfWork, setReadOnlyScopeOfWork] = useState(true);
  const [readOnlyAdditionalInfo, setReadOnlyAdditionalInfo] = useState(true);
  const [readOnlyTimeline, setReadOnlyTimeline] = useState(true);
  const [readOnlyBudget, setReadOnlyBudget] = useState(true);
  const [readOnlySource, setReadOnlySource] = useState(true);
  const [showShareButton, setShowShareButton] = useState(false);
  const [newGalleryUploaded, setNewGalleryUploaded] = useState([]);
  const [showGalleryUpload, setShowGalleryUpload] = useState(false);
  const [indexForAction, setIndexForAction] = useState(0);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const fileRef = useRef(null);
  const updateForm = (data) => {
    setForm({ ...form, ...data });
  };
  const setInput = (key) => (event) => {
    //setError
    setErrorText("");

    updateForm({ [key]: event.target.value });
  };
  const decodeBase64Json = (encodedString) => {
    // Step 1: Decode the base64 string
    const decodedString = atob(encodedString); // This gives the raw JSON string
    // Step 2: Parse the JSON string to convert it back to a JavaScript object
    try {
      const jsonObject = JSON.parse(decodedString);
      return jsonObject;
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return null; // Return null if there's an error
    }
  };
  const removeItem = (indexToRemove) => {
    setNewGalleryUploaded((prevItems) =>
      prevItems.filter((_, index) => index !== indexToRemove)
    );
    setShowConfirmDelete(false);
  };
  const previewImage = () => {
    const file = fileRef.current.files[0];
    console.log(file);
    if (
      (file.type.startsWith("image") === false &&
        file.type.startsWith("video") === false) ||
      fileRef.current.files[0].size > 10000000
    ) {
      addToast({
        error: true,
        date: new Date(),
        msg: " .GIF, .PNG, .JPG, .MP4, .MOV only with a maximum file size of 10MB",
      });
    } else {
      if (file) {
        try {
          uploadService.upload(file, true, 0, 1).then((text) => {
            const decryptedResponse = text && decodeBase64Json(text);
            const response = JSON.parse(decryptedResponse);
            if (response.message === "success") {
              const media_type_id = file.type.startsWith("image") ? "2" : 1;
              setPreview((prevPreview) => [
                ...prevPreview,
                {
                  mediafile: response.path,
                  file_type: response.file_type,
                  file_size: response.file_size,
                  file: response.path,
                  media_type_id: media_type_id,
                },
              ]);
              setIsLoadedImg(true);
            }
          });
        } catch (err) {
          addToast({
            error: true,
            date: new Date(),
            msg: "Error uploading file",
          });
        }
      }
    }
  };

  const addToast = (data) => {
    const newToastList = [...toastList];
    if (data.msg) {
      if (data.msg[data.msg.length - 1] === ".")
        data.msg = data.msg.slice(0, -1);
    }
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === "Enter") {
        createList.current.click();
      }
    };
    document.addEventListener("keydown", keyDownHandler);
    return () => {
      document.removeEventListener("keydown", keyDownHandler);
    };
  }, [form, isError]);
  const validateBriefData = async () => {
    setIsError(!isError);
    setErrorText("");

    if (
      form.title == "" ||
      form.additional_info == "" ||
      form.budget == "" ||
      form.goal == "" ||
      form.scope_of_work == "" ||
      form.timeline == ""
    ) {
      setError(true);
      addToast({
        error: true,
        date: new Date(),
        msg: "Enter All details to save brief",
      });
    } else {
      setReadOnlyAdditionalInfo(true);
      setReadOnlyBudget(true);
      setReadOnlyGoal(true);
      setReadOnlyTimeline(true);
      setReadOnlyTitle(true);
      setReadOnlyScopeOfWork(true);
      setError(false);
      setErrorText("");
      try {
        //  console.log(param)

        let param = { ...form, files: preview };
        const res = await briefService.saveBrief(param);
        console.log("API Response: ", res);

        console.log(param);
        if (res.success == true) {
          setShowShareButton(true);
          addToast({
            error: false,
            date: new Date(),
            msg: res.message,
          });
          // setGeneratedBriefResponse(res.data);
          //setTab('briefdata');
        }
      } catch (err) {
        addToast({
          error: true,
          date: new Date(),
          msg:
            typeof err === "string" ? err.replace(/<[^>]*>/g, "") : err.message,
        });
        //setTabModal("main")
      }
    }
  };
  const removeImgFromArray = (index) => {
    const temp = [...preview];
    temp.splice(index, 1);
    setPreview(temp);
  };
  console.log(newGalleryUploaded);
  return (
    <>
      <div className="assetsAdd__form">
        <div className="assetsAdd__form-title">
          <h6 className="small"></h6>
        </div>
        <div className="assetsAdd__form-inner briefStaticSection">
          {!readOnlyTitle ? (
            <>
              <div className={`assetsAdd__form-head briefBox`}>
                <TextInputWithReadOnly
                  value={form.title}
                  onChange={setInput("title")}
                  autoFocus
                  onClickPencil={() => setReadOnlyTitle(false)}
                  readOnly={readOnlyTitle}
                  showShareButton={showShareButton}
                />
                <div className="chracterscountForBrief">
                  {`${form.title.length} / 1000 characters`}
                </div>
                <div className="campaignsCreate__btns briefsave">
                  <div className="campaignsCreate__btns-row"></div>
                  <button
                    className="button primary"
                    onClick={() => {
                      setReadOnlyTitle(true);
                    }}
                  >
                    Save
                  </button>
                </div>
              </div>
              <div></div>
            </>
          ) : (
            <div
              className={`input__outer assetsAdd__form-head briefBox ${
                readOnlyTitle == true ? "briefBoxToSave" : ""
              } `}
            >
              <div className={"briefStaticData "}>
                <div className="briefInputbox titleOfBrief">{form.title}</div>
                {showShareButton == false && (
                  <span onClick={() => setReadOnlyTitle(false)}>
                    {pencilIcon}
                  </span>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="assetsAdd__form-inner briefStaticSection">
          {!readOnlyGoal ? (
            <div className={`assetsAdd__form-head briefBox`}>
              <TextAreaWithReadOnly
                value={form.goal}
                label="Goal"
                onChange={setInput("goal")}
                error={error}
                autoFocus
                readOnly={readOnlyGoal}
                onClickPencil={() => setReadOnlyGoal(false)}
                showShareButton={showShareButton}
              />{" "}
              <div className="chracterscountForBrief">
                {`${form.goal.length} / 1000 characters`}
              </div>
              <div className="campaignsCreate__btns briefsave">
                <div className="campaignsCreate__btns-row"></div>
                <button
                  className="button primary"
                  onClick={() => {
                    setReadOnlyGoal(true);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          ) : (
            <div
              className={`input__outer assetsAdd__form-head briefBox ${
                readOnlyTitle == true ? "briefBoxToSave" : ""
              } `}
            >
              <div className={"briefStaticData"}>
                <label className="label-with-icon">Goal</label>
                {showShareButton == false && (
                  <span onClick={() => setReadOnlyGoal(false)}>
                    {pencilIcon}
                  </span>
                )}
              </div>
              <div className="briefInputbox">{form.goal}</div>
            </div>
          )}
        </div>
        <div className="assetsAdd__form-inner briefStaticSection">
          {!readOnlyScopeOfWork ? (
            <div className={`assetsAdd__form-head briefBox`}>
              <TextAreaWithReadOnly
                value={form.scope_of_work}
                label="Scope of work"
                onChange={setInput("scope_of_work")}
                error={error}
                autoFocus
                readOnly={readOnlyScopeOfWork}
                onClickPencil={() => setReadOnlyScopeOfWork(false)}
                showShareButton={showShareButton}
              />
              <div className="chracterscountForBrief">
                {`${form.scope_of_work.length} / 1000 characters`}
              </div>
              <div className="campaignsCreate__btns briefsave">
                <div className="campaignsCreate__btns-row"></div>
                <button
                  className="button primary"
                  onClick={() => {
                    setReadOnlyScopeOfWork(true);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          ) : (
            <div
              className={`input__outer assetsAdd__form-head briefBox ${
                readOnlyTitle == true ? "briefBoxToSave" : ""
              } `}
            >
              <div className={"briefStaticData"}>
                <label className="label-with-icon">Scope of work</label>
                {showShareButton == false && (
                  <span onClick={() => setReadOnlyScopeOfWork(false)}>
                    {pencilIcon}
                  </span>
                )}
              </div>
              <div className="briefInputbox">{form.scope_of_work}</div>
            </div>
          )}
        </div>

        <div className="assetsAdd__form-inner briefStaticSection">
          {!readOnlyTimeline ? (
            <div className={`assetsAdd__form-head briefBox`}>
              <TextAreaWithReadOnly
                value={form.timeline}
                label="Timeline"
                onChange={setInput("timeline")}
                error={error}
                autoFocus
                readOnly={readOnlyTimeline}
                onClickPencil={() => setReadOnlyTimeline(false)}
                showShareButton={showShareButton}
              />
              <div className="chracterscountForBrief">
                {`${form.timeline.length} / 1000 characters`}
              </div>
              <div className="campaignsCreate__btns briefsave">
                <div className="campaignsCreate__btns-row"></div>
                <button
                  className="button primary"
                  onClick={() => {
                    setReadOnlyTimeline(true);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          ) : (
            <div
              className={`input__outer assetsAdd__form-head briefBox ${
                readOnlyTitle == true ? "briefBoxToSave" : ""
              } `}
            >
              <div className={"briefStaticData"}>
                <label className="label-with-icon">Timeline</label>
                {showShareButton == false && (
                  <span onClick={() => setReadOnlyTimeline(false)}>
                    {pencilIcon}
                  </span>
                )}
              </div>
              <div className="briefInputbox">{form.timeline}</div>
            </div>
          )}
        </div>

        <div className="assetsAdd__form-inner briefStaticSection">
          {!readOnlyBudget ? (
            <div className={`assetsAdd__form-head briefBox`}>
              <div className={"input__outer"}>
                {<label>Budget</label>}
                <div className={"input"}>
                  {<div className="input__outer"></div>}
                  <input
                    onChange={setInput("budget")}
                    value={form.budget}
                    type={"text"}
                  />
                </div>
              </div>
              <div className="campaignsCreate__btns briefsave">
                <div className="campaignsCreate__btns-row"></div>
                <button
                  className="button primary"
                  onClick={() => {
                    setReadOnlyBudget(true);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          ) : (
            <div
              className={`input__outer assetsAdd__form-head briefBox ${
                readOnlyBudget == true ? "briefBoxToSave" : ""
              } `}
            >
              <div className={"briefStaticData"}>
                <label className="label-with-icon">Budget</label>
                {showShareButton == false && (
                  <span onClick={() => setReadOnlyBudget(false)}>
                    {pencilIcon}
                  </span>
                )}
              </div>
              <div className="briefInputbox">{form.budget}</div>
            </div>
          )}
        </div>
        <div className="assetsAdd__form-inner briefStaticSection">
          {!readOnlyAdditionalInfo ? (
            <div className={`assetsAdd__form-head briefBox`}>
              <TextAreaWithReadOnly
                value={form.additional_info}
                label="Additional info"
                onChange={setInput("additional_info")}
                error={error}
                autoFocus
                readOnly={readOnlyAdditionalInfo}
                onClickPencil={() => setReadOnlyAdditionalInfo(false)}
                showShareButton={showShareButton}
              />
              <div className="chracterscountForBrief">
                {`${form.additional_info.length} / 1000 characters`}
              </div>
              <div className="campaignsCreate__btns briefsave">
                <div className="campaignsCreate__btns-row"></div>
                <button
                  className="button primary"
                  onClick={() => {
                    setReadOnlyAdditionalInfo(true);
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          ) : (
            <div
              className={`input__outer assetsAdd__form-head briefBox ${
                readOnlyTitle == true ? "briefBoxToSave" : ""
              } `}
            >
              <div className={"briefStaticData"}>
                <label className="label-with-icon">Additional info</label>
                {showShareButton == false && (
                  <span onClick={() => setReadOnlyAdditionalInfo(false)}>
                    {pencilIcon}
                  </span>
                )}
              </div>
              <div className="briefInputbox">{form.additional_info}</div>
            </div>
          )}
        </div>
        {showGalleryUpload && (
          <GalleryAdd
            close={() => showGalleryUpload(null)}
            setTab={setTab}
            setToastList={setToastList}
            toastList={toastList}
            uploadOnServer={false}
            setNewGalleryUploaded={setNewGalleryUploaded}
            newGalleryUploaded={newGalleryUploaded}
            briefImage={true}
            setShowGalleryUpload={setShowGalleryUpload}
          />
        )}
        {showShareButton == false && (
          <div>
            <button
              className="button tertiary big addGalleryButton briefUploadFile"
              onClick={() => setShowGalleryUpload(true)}
            >
              Upload File{plusIcon}
            </button>
          </div>
        )}
        <div className="assets__items ">
          {newGalleryUploaded.map((item, index) => {
            return (
              <GalleryGridItem
                key={index}
                setShowConfirmInfModal={() => {}}
                media_type_id={item.media_type_id}
                media_url={item.thumbnail_url}
                status={"visible"}
                newAddedImage={true}
                {...item}
                indexForItem={index}
                setIndexForAction={setIndexForAction}
                setShowConfirmDelete={setShowConfirmDelete}
              />
            );
          })}
        </div>
        <div className="campaignsCreate__btns">
          <div className="campaignsCreate__btns-row">
            <button className="button secondary" onClick={() => setTab("main")}>
              Cancel
            </button>
          </div>
          {showShareButton == false ? (
            <button className="button primary" onClick={validateBriefData}>
              Save Brief
            </button>
          ) : (
            <button className="button primary">Share Brief</button>
          )}
        </div>
      </div>
      {showConfirmDelete == true && (
        <Modal addClass="modalAsset" close={() => setShowConfirmDelete(false)}>
          <div className="modal__rate">
            <h6 className="mb">Are you sure you want to delete this media?</h6>
            <div className="modal__rate-btns">
              <button
                className="button secondary"
                onClick={() => setShowConfirmDelete(false)}
              >
                Cancel
              </button>
              <button
                className="button primary"
                onClick={() => removeItem(indexForAction)}
              >
                Delete
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
}
